import React, { Component } from 'react';
import { Input } from '.';

class DatePicker extends Component {  
  render() {
    const { onChange, label, display, type = 'date', value, width, margin } = this.props
    return (
      <Input
        label={label}
        value={value}
        width={width}
        margin={margin}
        display={display}
        onChange={onChange}
        type={type}/>
    )
  }
}

export default DatePicker


// WEBPACK FOOTER //
// ./src/components/Form/DatePicker.js